/* eslint-disable react/prop-types */

import { useSelector } from "react-redux";
// material
import { Box, Grid, Container, Typography } from "@mui/material";
// components
import Page from "../Page";
import {
  PlainteEnCours,
  PlainteTotal,
  PlaineDeliberee,
  PlainteBrute,
  StatsBeignet,
  StatsPie,
} from "../_dashboard/app";

// ----------------------------------------------------------------------

export default function DashboardApp({ dataStat }) {
  const { userFirstname } = useSelector((state) => state.authReducer);
  const { userLastname } = useSelector((state) => state.authReducer);

  return (
    <Page title="Dashboard | Gestion des plaintes">
      <Container maxWidth="xl">
        <Box sx={{ pb: 5 }}>
          <Typography variant="h4">
            {userFirstname} {userLastname}{" "}
          </Typography>
        </Box>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} md={3}>
            <PlainteBrute dataStat={dataStat} />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <PlainteEnCours dataStat={dataStat} />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <PlaineDeliberee dataStat={dataStat} />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <PlainteTotal dataStat={dataStat} />
          </Grid>

          <Grid item xs={12} md={6} lg={8}>
            <StatsPie dataStat={dataStat} />
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <StatsBeignet dataStat={dataStat} />
          </Grid>
        </Grid>
      </Container>
    </Page>
  );
}
